import React from "react";
import { Button } from '@mui/material';
import { DialogContent, Dialog, DialogTitle, DialogActions, DialogContentText } from '@mui/material';

export const DistrictChangePopover = (props) => {
    return (
        <Dialog maxWidth='xs' fullWidth open={props.onOpen}>
            <DialogTitle>
            Are you sure you want to change the district ?
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                You will lose all the data that you have added for the current district but not yet submitted.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Cancel</Button>
                <Button onClick={props.onConfirm}>Confirm</Button>
            </DialogActions>
        </Dialog>
    );
};
